/**
 * @generated SignedSource<<3477cbd9bd7a2602e2a6ad008eaf864d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetail_detailValues$data = ReadonlyArray<{
  readonly browseUrl: string | null;
  readonly detailKey: string | null;
  readonly displayDetails: string | null;
  readonly displayName: string | null;
  readonly price?: {
    readonly convertedAmountList: ReadonlyArray<{
      readonly amount: number | null;
      readonly currency: Currency | null;
    } | null> | null;
  } | null;
  readonly skuId: string | null;
  readonly " $fragmentType": "PdpSharedDetail_detailValues";
}>;
export type PdpSharedDetail_detailValues$key = ReadonlyArray<{
  readonly " $data"?: PdpSharedDetail_detailValues$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetail_detailValues">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpSharedDetail_detailValues",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "detailKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayDetails",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skuId",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmountList",
              "kind": "LinkedField",
              "name": "convertedAmountList",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PdpDetailVersionsValue",
      "abstractKey": null
    }
  ],
  "type": "PdpDetailValueInterface",
  "abstractKey": "__isPdpDetailValueInterface"
};

(node as any).hash = "db9ad437bebd07ae23d900eeca2d9a5c";

export default node;
